import mixpanel from 'mixpanel-browser'
import { AnalyticsProvider } from '@/core/analytics/AnalyticsProvider.ts'
import { AnalyticsEvent } from './events/AnalyticsEvent.ts'

class MixpanelAnalyticsProvider implements AnalyticsProvider {
  init(token: string): void {
    mixpanel.init(token)
  }

  identify(userId: string): void {
    mixpanel.identify(userId)
  }

  setUserProperties(properties: Record<string, unknown>): void {
    mixpanel.people.set(properties)
  }

  track(event: AnalyticsEvent): void {
    const hasProperties = Object.keys(event.properties).length > 0

    mixpanel.track(event.name, hasProperties ? event.properties : undefined)
  }
}

export { MixpanelAnalyticsProvider }
